export interface EstateInsuranceData {
  id: string;
  estateId: string;
  insuranceCompanyNIP: string;
  insuranceCompany: string;
  policyNo: string;
  startDate: number;
  endDate: number;
  totalPremium: number;
  insuranceSum: number;
  isOCManagement: boolean;
  note: string;
  currency: string;
  status: InsuranceStatus;
  /** storage path */
  attachments: string[];
}

export enum InsuranceStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  FUTURE = 'future'
}

